import React, {useEffect, useState} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Alert, Button, Card, Divider, Modal, Popover, Select, Skeleton, Space, Spin, Table} from 'antd';
import useAuth from '../../utils/AuthContext';
import Text from 'antd/lib/typography/Text';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {PaymentApi, PaymentDto, PaymentGood, PaymentStatus} from '../../scaffold';
import {useBoolean} from 'react-hanger';
import {QRCodeSVG} from 'qrcode.react';

export default function ProfilePaymentPage() {
  const auth = useAuth();
  if (!auth.currentUser) return <div>请先登录</div>;
  const paymentList = [
    {name: '1 年（学生会员）', price: 20},
    {name: '1 年', price: 50},
    {name: '2 年', price: 40, disabled: true},
    {name: '3 年', price: 60, disabled: true},
    {name: '4 年', price: 80, disabled: true},
    {name: '5 年', price: 100, disabled: true},
    {name: '永久', price: 500, disabled: true},
  ];
  const [paymentOption, setPaymentOption] = useState('1 年');
  const isShowPay = useBoolean(false);
  const getPayUrlHook = useOpenApiFpRequest(PaymentApi, PaymentApi.prototype.paymentGetPaymentUrlPost);
  const listPayments = useOpenApiFpRequest(PaymentApi, PaymentApi.prototype.paymentListPaymentGet);
  function showPay() {
    isShowPay.setTrue();
    let paymentGood = PaymentGood.永久;
    if (paymentOption === '1 年（学生会员）') paymentGood = PaymentGood.学生会员一年;
    if (paymentOption === '1 年') paymentGood = PaymentGood.一年;
    if (paymentOption === '2 年') paymentGood = PaymentGood.二年;
    if (paymentOption === '3 年') paymentGood = PaymentGood.三年;
    if (paymentOption === '4 年') paymentGood = PaymentGood.四年;
    if (paymentOption === '5 年') paymentGood = PaymentGood.五年;
    getPayUrlHook.requestSync({getPaymentUrlParams: {paymentGood}});
  }
  function refreshPayments() {
    isShowPay.setFalse();
    listPayments.requestSync({});
  }
  useEffect(() => {
    if (auth.currentUser) refreshPayments();
  }, [auth.currentUser]);
  return (
    <AppSideLayout title={'会员缴费'}>
      <Card style={{flex: 1}} title={'会员缴费'}>
        <div className={'m-b-10'}>
          <Space>
            <Text strong>当前账号:</Text>
            <Text>{auth.currentUser.personalApprove?.name}</Text>
          </Space>
        </div>
        <div className={'m-b-10'}>
          <Space>
            <Text strong>缴费时长:</Text>
            <Select value={paymentOption} onChange={setPaymentOption} style={{width: 200}}>
              {paymentList.map(p => (
                <Select.Option value={p.name} key={p.name} disabled={p.disabled}>
                  {p.name} {p.disabled && '调整中'}
                </Select.Option>
              ))}
            </Select>
          </Space>
        </div>
        <div className={'m-b-10'}>
          <Space>
            <Text strong>支付金额:</Text>
            <div>
              <Text style={{color: 'red', fontSize: 28, marginRight: 5, fontWeight: 'bold'}}>{paymentList.find(i => i.name === paymentOption)?.price}</Text>
              <Text strong>元</Text>
            </div>
          </Space>
        </div>
        <div className={'m-b-10'}>
          <Space>
            <Text strong>支付方式:</Text>
            <div>
              <Button type={'primary'} onClick={showPay}>
                微信支付
              </Button>
            </div>
          </Space>
        </div>
        <Alert message={'如需要会费缴纳凭证，请联系学会办公室（快递到付）电话：021-53828933'} showIcon />
        <Modal title={'微信支付'} visible={isShowPay.value} closable={false} footer={false} width={400}>
          <div className={'text-center'}>
            <div className={'m-b-10'}>使用微信 APP 扫描下方二维码付款</div>
            <div>
              <Skeleton loading={getPayUrlHook.loading}>
                <QRCodeSVG value={getPayUrlHook.data?.codeUrl || ''} />
              </Skeleton>
            </div>
            <Space className={'m-t-10 m-b-20'}>
              <Button onClick={isShowPay.setFalse}>取消支付</Button>
              <Button type={'primary'} onClick={refreshPayments}>
                我已完成支付
              </Button>
            </Space>
          </div>
        </Modal>
        <Divider>缴费记录</Divider>
        <Table size={'small'} loading={listPayments.loading} dataSource={listPayments.data} key={'id'} bordered>
          <Table.Column<PaymentDto> title={'商户订单号'} render={(_, i) => i.outTradeNumber} />
          <Table.Column<PaymentDto> title={'会员姓名'} render={(_, i) => i.user?.personalApprove?.name} />
          <Table.Column<PaymentDto> title={'缴费选项'} render={(_, i) => i.paymentGood} />
          <Table.Column<PaymentDto>
            title={'支付状态'}
            render={(_, i) => {
              if (i.status === PaymentStatus.未支付)
                return (
                  <Popover content={<QRCodeSVG value={i.codeUrl || ''} />}>
                    <a>{i.status}</a>
                  </Popover>
                );
              return i.status;
            }}
          />
          <Table.Column<PaymentDto> title={'支付时间'} render={(_, i) => i.paidTime} />
          <Table.Column<PaymentDto> title={'创建时间'} render={(_, i) => i.createdTime} />
        </Table>
      </Card>
    </AppSideLayout>
  );
}
